var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-right"},[_vm._v(" ©2023 LOTUS ROBOTICS "+_vm._s(_vm.$t("footer.copyRight") + " ")+" "),_c('span',{on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.$t("footer.filling")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }